import React from 'react';
import '../../components/CSS/About.css';
import ServiceHero from '../../components/ServiceHero';
import { useParams } from 'react-router-dom';
import { servicesData } from '../../Helpers/ServicesHelper';
import ServiceProcess from '../../components/ServiceProcess';
import Testimonials from '../../components/Testimonials';
import CTA from '../../components/CTA';
import ContactUs from '../../components/ContactUs';
import ServiceWhyFixinn from '../../components/ServiceWhyFixinn';
import ServicesGrid from '../../components/ServicesGrid';
import SEOHead from '../../components/SEO/SEOHead';
import { serviceDetailSEO } from '../../components/SEO/seoConfig';
import {
  createServiceSchema,
  createBreadcrumbSchema,
  phoneRepairServiceSchema,
  laptopRepairServiceSchema,
  techSupportServiceSchema,
  computerCoachingServiceSchema,
  tennisCoachingServiceSchema,
  watchRepairServiceSchema
} from '../../components/SEO/schemas';

const ServiceDetail = () => {
  const { id } = useParams();
  let service = servicesData[id];

  // Get SEO config for this service or use default
  const seoData = serviceDetailSEO[id] || {
    title: `${service?.title || 'Service'} - Professional Home Repair | FixiNN`,
    description: `Professional ${service?.title || 'home repair'} services. Expert technicians, quality work guaranteed.`,
    keywords: `${service?.title || 'home repair'}, professional services, home improvement, fixinn`,
    canonical: `${process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk'}/services/${id}`
  };

  const breadcrumbs = [
    { name: 'Home', url: process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk' },
    { name: 'Services', url: `${process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk'}/services` },
    { name: service?.title || 'Service', url: seoData.canonical }
  ];

  // Get specific service schema based on service ID
  const getServiceSchema = () => {
    switch (id) {
      case 'phone-repair-service':
        return phoneRepairServiceSchema;
      case 'laptop-repair-services':
        return laptopRepairServiceSchema;
      case 'home-tech-support':
        return techSupportServiceSchema;
      case 'computer-coaching-service':
        return computerCoachingServiceSchema;
      case 'tennis-coaching-service':
        return tennisCoachingServiceSchema;
      case 'watch-repair-service':
        return watchRepairServiceSchema;
      default:
        return createServiceSchema(
          service?.title || 'Home Repair Service',
          service?.description || 'Professional home repair and maintenance services',
          service?.price
        );
    }
  };

  const serviceSchema = getServiceSchema();
  const combinedSchema = [serviceSchema, createBreadcrumbSchema(breadcrumbs)];

  return (
    <>
      {/* <SEOHead
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        ogTitle={seoData.title}
        ogDescription={seoData.description}
        ogUrl={seoData.canonical}
        structuredData={combinedSchema}
      /> */}
      <div className="about-page">
        <ServiceHero service={service} />
        <ServicesGrid service={service} />
        <ServiceProcess service={service} />
        <ServiceWhyFixinn service={service} />
        <Testimonials background={"transparent"} />
        <CTA background={"#B30F29"} />
        <ContactUs />
      </div>
    </>
  );
};

export default ServiceDetail;